
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ModalAddSkill extends Vue {

  /* PROP */

  @Prop({default: []})
  private skills: string[];
  @Prop({default: false})
  private isShow: boolean;

  /* INITIALIZATION */

  private skill: string = '';

  constructor() {
    super();
  }

  /* METHOD */

  private addSkill() {
    this.$emit('update:isShow', false);
    if (this.skill) {
      this.skills.push(this.skill);
      this.skill = '';
    }
  }
}
